import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=17913feb"
import script from "./CopyModal.vue?vue&type=script&lang=ts"
export * from "./CopyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports